import { CtaButton } from '@tkww/orion-web-ds-action';
import React, { useState } from 'react';
import { useTrackEditEstimateCTA } from '../../hooks/useTrackEditEstimateCTA';
import { EditEstimateFormModal } from '../EditEstimateFormModal';
import Styles from './styles.scss';

export const EditEstimateCTA = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const trackEditEstimateCTA = useTrackEditEstimateCTA();

	const handleClick = () => {
		trackEditEstimateCTA();
		setIsModalOpen(true);
	};

	return (
		<>
			<CtaButton
				styleType="secondary"
				size="md"
				onClick={handleClick}
				className={Styles.editEstimateCta}
				data-testid="edit-estimate-cta-button"
				iconName={'pencil' as const}
				labelDirection={'right' as const}
			>
				Edit your wedding details
			</CtaButton>
			<EditEstimateFormModal
				isModalOpen={isModalOpen}
				closeCallback={() => setIsModalOpen(false)}
			/>
		</>
	);
};
